/**
 * JSON Syntax Highlighting
 *
 * Extracted from HierarchicalMetadataExample for production use.
 * Returns HTML strings with CSS class-based highlighting.
 *
 * CSS classes used:
 *   .json-key     - object keys
 *   .json-string  - string values
 *   .json-number  - numeric values
 *   .json-boolean - true/false
 *   .json-null    - null
 */

/**
 * Convert a JSON value to syntax-highlighted HTML string.
 * Handles string input (parsed), objects, and non-JSON gracefully.
 */
export function syntaxHighlight(input: unknown): string {
  try {
    const json = typeof input === 'string' ? JSON.parse(input) : input;
    const str = JSON.stringify(json, null, 2);
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(
        /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"\s*:)|("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*")|(\b(true|false)\b)|(\bnull\b)|(-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g,
        (match) => {
          if (/^".*"\s*:/.test(match)) return `<span class="json-key">${match}</span>`;
          if (/^".*"$/.test(match)) return `<span class="json-string">${match}</span>`;
          if (/true|false/.test(match)) return `<span class="json-boolean">${match}</span>`;
          if (/null/.test(match)) return `<span class="json-null">${match}</span>`;
          return `<span class="json-number">${match}</span>`;
        },
      );
  } catch {
    const safe = String(input).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return `<span class="json-string">${safe}</span>`;
  }
}
